const LoginBg = () => {
  return (
    <div
      className="font-darker relative h-dvh w-screen bg-cover bg-center bg-no-repeat px-4 pt-6 text-white"
      style={{
        backgroundImage: "url('/images/auth-img.svg')",
      }}
    >
      <h1 className="pr-12 text-[40px] leading-12 font-extrabold md:text-7xl">
       Your Gateway to Smarter {" "}
        <span className="text-auth-accent">Digital Finance.</span>
      </h1>
      <p className="mt-4 text-xl font-semibold md:text-3xl">
     Easily create virtual cards to handle every online purchase, bill and subscription.
      </p>

      {/* <img src="/images/login-icon-set.svg" className="mt-6 md:w-40" alt="" /> */}

      <img
        className="absolute top-2/5 left-1/2 -translate-x-1/2 right-0 z-10 w-4/5 min-w-80 -translate-y-1/3 md:w-[600px]"
        src="/images/login-atm.webp"
        alt="Atm cards"
      />

      {/* <img
        src="/images/login-bg-line.svg"
        alt=""
        className="absolute inset-x-0 bottom-0 z-0 w-full"
      /> */}

      {/* Home-indicator pill. A real element rather than part of the background,
          so it stays 56×12 — `bg-cover` scales the 390×844 artwork up on wider
          viewports and would scale a baked-in pill with it. Position matches the
          rect in `auth-img.svg` (x 37, 64px off the bottom). */}
      <svg
        className="absolute bottom-16 left-9 z-10"
        width="56"
        height="12"
        viewBox="0 0 56 12"
        fill="none"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="56" height="12" rx="6" fill="url(#login-bg-pill)" />
        <defs>
          <linearGradient
            id="login-bg-pill"
            x1="28"
            y1="12"
            x2="28"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EAC37B" />
            <stop offset="1" stopColor="#B28A40" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default LoginBg;
